<jni-add-contact-information
  #contactForm
  [(display)]="displayAddContact"
  *ngIf="displayAddContact"
  [clientObject]="clientObject"
  [headingStatus]="contactHeadingStatus"
  [clientIdFromModal]="clientId"
  (refreshSummary)="refreshingSummary()">
</jni-add-contact-information>

<jni-add-address-information
  [(display)]="displayCreateAddress"
  *ngIf="displayCreateAddress"
  [addressObject]="addressObject"
  [headingStatus]="addressHeadingStatus"
  [clientIdFromModal]="clientId"
  [isPrimaryFieldStatus]="false"
  (refreshSummary)="refreshingSummary()">
</jni-add-address-information>

<jni-view-contact-information
  [(display)]="displayViewContact"
  *ngIf="displayViewContact"
  [clientIdFromModal]="clientId"
  (editEvent)="onOpenEditContact($event)"
  (refreshGrid)="onEditContactUpdated($event)">
</jni-view-contact-information>

<jni-view-address-information
  [(display)]="displayViewAddress"
  *ngIf="displayViewAddress"
  [clientIdFromModal]="clientId"
  (editEvent)="onOpenEditAddress($event)"
  (refreshGrid)="onEditAddressUpdated($event)">
</jni-view-address-information>

<!-- <div class="clientdetails py-1">
  <header class="d-flex align-items-center justify-content-between mb-4">
    <div class="align-items-center d-flex position-rel">
      <h1 class="me-auto me-3">
        Client # {{ clientId }} -
        {{ clientBasicInformation?.organizationNameD365 }}
      </h1>
      <div class="lds-ring inline me-auto ms-2" *ngIf="showSmallLoader">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>

    <div class="d-flex clientdetails-date ml-auto">
      <div class="me-2">
        <span class="me-1 title">Last Order:</span>
        <time *ngIf="lastOrderDate | hidedynamicsdate">{{
          lastOrderDate | date: "MM-dd-yyyy"
        }}</time>
      </div>
      <div class="me-2">
        <span class="me-1 title">Invoice:</span>
        <time *ngIf="invoiceDate | hidedynamicsdate">{{
          invoiceDate | date: "MM-dd-yyyy"
        }}</time>
      </div>
    </div>
  </header>
  <div class="row">
    <div class="col pb-4">
      <div class="card text-center">
        <div class="card-body d-flex flex-column justify-content-center">
          <h3 class="card-title mb-2">{{ customerBalance | currency }}</h3>
          <p class="card-text">Available Credit</p>
        </div>
      </div>
    </div>
    <div class="col pb-4">
      <div class="card text-center order-five">
        <div class="card-body d-flex flex-column justify-content-center">
          <h3 class="card-title mb-2">
            {{ FYTDSales | currency }}
          </h3>
          <p class="card-text">FYTD Sales</p>
        </div>
      </div>
    </div>
    <div class="col pb-4">
      <div class="card text-center order-one">
        <div class="card-body d-flex flex-column justify-content-center">
          <h3 class="card-title mb-2">
            {{ openOrders | currency }}
          </h3>
          <p class="card-text">Open Orders</p>
        </div>
      </div>
    </div>
    <div class="col pb-4">
      <a class="link" (click)="redirectToArAgingDetailsReport(clientId, '60')">
        <div class="card text-center order-two">
          <div class="card-body d-flex flex-column justify-content-center">
            <h3 class="card-title mb-2">
              {{ openInvoiceAmountTilesData.openAmount60 | currency }}
            </h3>
            <p class="card-text">60</p>
          </div>
        </div>
      </a>
    </div>
    <div class="col pb-4">
      <a class="link" (click)="redirectToArAgingDetailsReport(clientId, '90')">
        <div class="card text-center order-two">
          <div class="card-body d-flex flex-column justify-content-center">
            <h3 class="card-title mb-2">
              {{ openInvoiceAmountTilesData.openAmount90 | currency }}
            </h3>
            <p class="card-text">90</p>
          </div>
        </div>
      </a>
    </div>
    <div class="col pb-4">
      <a class="link" (click)="redirectToArAgingDetailsReport(clientId, '120')">
        <div class="card text-center order-two">
          <div class="card-body d-flex flex-column justify-content-center">
            <h3 class="card-title mb-2">
              {{ openInvoiceAmountTilesData.openAmount120 | currency }}
            </h3>
            <p class="card-text">120+</p>
          </div>
        </div>
      </a>
    </div>
  </div>
  <div class="row">
    <div class="col d-flex align-items-center justify-content-between">
      <ul class="nav sidenav mb-3">
        <li class="nav-item me-4">
          <a
            class="nav-link p-0"
            (click)="redirectToOpenCustomerInvoices(clientId)"
            aria-current="page"
            >Open Customer Invoices</a
          >
        </li>
        <li class="nav-item me-4">
          <a class="nav-link p-0" (click)="orderHistoryRedirect()"
            >Order History</a
          >
        </li>

        <li class="nav-item me-4">
          <a
            class="nav-link p-0"
            aria-current="page"
            (click)="redirectClientArchive()"
            >Archived Projects</a
          >
        </li>
      </ul>
      <a
        (click)="onToggle()"
        [ngClass]="{ active: collapseStatus }"
        class="btn-collapse-all"
        >{{ collapseHeading }} <i class="icon-angle-double ms-2"></i
      ></a>
    </div>
  </div>
  <div class="row">
    <div class="col-8">
      <form [formGroup]="clientSummaryForm">
        <div class="clientdetails-section mb-4">
          <p-panel [toggleable]="true" [(collapsed)]="isCollapsed">
            <ng-template pTemplate="header">
              <div
                class="d-flex align-items-center justify-content-between ">
                <h2 class="mb-0">Basic Information</h2>
              </div>
            </ng-template>
            <div class="px-3 py-4">
              <div class="row">
                <div class="col-3 mb-3">
                  <div class="title">Client Name:</div>
                  <div class="text">
                    {{ clientBasicInformation?.organizationNameD365 }}
                  </div>
                </div>
                <div class="col-3 mb-3">
                  <div class="title">Branding Consultant:</div>
                  <div class="text">
                    {{ clientBasicInformation?.brandingConsultantD365 }}
                  </div>
                </div>
                <div class="col-3 mb-3">
                  <div class="title">Brand Acc Coordinator:</div>
                  <p-select pInputText
                    class="p-0 no-border"
                    id="inStoreCCProvider"
                    [(ngModel)]="bacUserDefaultSelectionId"
                    (onBlur)="updateClientSummaryData()"
                    formControlName="brandingAccountCordinator"
                    [options]="bacList"
                    optionValue="personnelNumber"
                    placeholder="Select Brand Acc Coordinator">
                    <ng-template let-item #item>
                      {{ item.personnelNumber }} : {{ item.projectName }}
                    </ng-template>
                  </p-select>
                </div>
                <div class="col-3 mb-3">
                  <div class="title">Known As:</div>
                  <input pInputText 
                    jniAutoCompleteBlocker
                    type="text"
                    id="bac"
                    class="hideborder"
                    formControlName="knownAsD365"
                    (focusout)="updateClientSummaryData()" />
                </div>
              </div>
              <div class="row">
                <div class="col-3 mb-3">
                  <div class="title">
                    Client Group<span class="madatory-field">*</span>:
                  </div>
                  <p-select pInputText
                    class="p-0 no-border"
                    id="sourcetype"
                    (onBlur)="updateClientSummaryData()"
                    formControlName="customerGroupIdD365"
                    [options]="customerGroupList"
                    optionValue="customerGroupIdD365"
                    optionLabel="customerGroupIdD365"
                    placeholder="Select Facililator">
                  </p-select>
                </div>
                <div class="col-3 mb-3">
                  <div class="title">Type:</div>
                  <div class="text">
                    {{ clientBasicInformation?.partyTypeD365 }}
                  </div>
                </div>
                <div class="col-3 mb-3">
                  <div class="title">Parent Company Name:</div>
                  <p-autoComplete
                    [(ngModel)]="parentCompanyName"
                    [suggestions]="filteredParentCompanies"
                    (completeMethod)="filterParentCompanies($event)"
                    field="nameAliasD365"
                    [dropdown]="true"
                    [forceSelection]="true"
                    [formControlName]="'rsmJNIParentCompanyNameD365'"
                    (onBlur)="updateClientSummaryData()"
                    [styleClass]="'hideborder'"
                    placeholder="Search Parent Company"></p-autoComplete>
                </div>
                <div class="col-3 mb-3">
                  <div class="title">Source:</div>
                  <p-select pInputText
                    class="p-0 no-border"
                    id="source"
                    (onBlur)="updateClientSummaryData()"
                    formControlName="source"
                    [options]="sourceList"
                    optionValue="sourcetype"
                    optionLabel="sourcetype"
                    placeholder="Select sourcetype">
                  </p-select>
                </div>
              </div>
              <div class="row">
                <div class="col-3 mb-3">
                  <div class="title">Currency:</div>
                  <p-select pInputText
                    class="p-0 no-border"
                    id="currency"
                    (onBlur)="updateClientSummaryData()"
                    formControlName="salesCurrencyCodeD365"
                    [options]="currencyList"
                    optionValue="isoCurrencyCodeD365"
                    optionLabel="isoCurrencyCodeD365"
                    placeholder="Select isoCurrencyCodeD365">
                  </p-select>
                </div>
                <div class="col-3 mb-3">
                  <div class="title">Company URL:</div>
                  <input pInputText 
                    jniAutoCompleteBlocker
                    type="text"
                    id="companyurl"
                    class="hideborder"
                    formControlName="companyUrl"
                    (focusout)="updateClientSummaryData()" />
                </div>
                <div class="col-3 mb-3">
                  <div class="title">DUNS#:</div>
                  <input pInputText 
                    jniAutoCompleteBlocker
                    type="text"
                    id="dunsno"
                    class="hideborder"
                    formControlName="dUNSNoD365"
                    (focusout)="updateClientSummaryData()" />
                </div>
                <div class="col-3 mb-3">
                  <div class="title mb-1">Request Credit Check:</div>
                  <div class="form-check form-switch d-flex gap-2 align-items-center">
                    <input pInputText 
                      name="rcCheck"
                      class="form-check-input me-2"
                      [checked]="clientBasicInformation?.isRequestCreditCheck"
                      type="checkbox"
                      (click)="onRequestCreditCheckSelection($event)"
                      id="rcCheck"
                      formControlName="isRequestCreditCheck"
                      (onChange)="updateClientSummaryData()" />
                    <label class="form-check-label" for="rcCheck">{{
                      clientBasicInformation?.isRequestCreditCheck
                    }}</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-3 mb-3">
                  <div class="title mb-1">Resale:</div>
                  <div class="form-check form-switch d-flex gap-2 align-items-center">
                    <input pInputText 
                      class="form-check-input me-2"
                      checked
                      type="checkbox"
                      id="resalestatus"
                      name="resalestatus"
                      disabled
                      [checked]="clientBasicInformation?.isResale"
                      (click)="onIsResale($event)" />
                    <label class="form-check-label" for="resalestatus">{{
                      clientBasicInformation?.isResale
                    }}</label>
                  </div>
                </div>
                <div class="col-3 mb-3">
                  <div class="title">Resale Certificate:</div>
                  <div
                    class="text"
                    [hidden]="!clientBasicInformation?.isResale">
                    <a
                      class="link"
                      [href]="resaleAttachmenturl"
                      target="_blank"
                      >{{ descriptionD365 }}</a
                    >
                  </div>
                  <div [hidden]="clientBasicInformation?.isResale">
                    <jni-attachment
                      [attachmentLabel]="resale"
                      [fileName]="resale"
                      #myDiv
                      (attachmentFileEvent)="
                        attachmentFileObject($event)
                      "></jni-attachment>
                  </div>
                </div>
                <div class="col-3 mb-3">
                  <div class="title mb-1">Tax Exemption#:</div>
                  <div class="form-check form-switch d-flex gap-2 align-items-center">
                    <input pInputText 
                      class="form-check-input me-2"
                      [checked]="clientBasicInformation?.isTaxExemption"
                      disabled
                      type="checkbox"
                      id="tAssumption"
                      name="tAssumption"
                      (click)="onTaxExemption($event)" />
                    <label class="form-check-label" for="tAssumption">{{
                      clientBasicInformation?.isTaxExemption
                    }}</label>
                  </div>
                </div>
                <div class="col-3 mb-3">
                  <div class="title">Tax Exemption:</div>
                  <div
                    class="text"
                    [hidden]="!clientBasicInformation?.isTaxExemption">
                    <a class="link" [href]="taxAttachmenturl" target="_blank">{{
                      taxdescriptionD365
                    }}</a>
                  </div>
                  <div [hidden]="clientBasicInformation?.isTaxExemption">
                    <jni-attachment
                      [attachmentLabel]="taxexemption"
                      [fileName]="taxexemption"
                      (attachmentFileEvent)="
                        attachmentFileObject($event)
                      "></jni-attachment>
                  </div>
                </div>
              </div>
              <footer class="pt-3">
                <div class="row">
                  <div class="col-3">
                    <div class="title mb-1">State Date:</div>
                    <div class="text">
                      {{
                        clientBasicInformation?.createdDate | date: "MM-dd-yyyy"
                      }}
                    </div>
                  </div>
                  <div class="col">
                    <div class="title mb-1">
                      Collector:
                      <a class="link">{{
                        clientBasicInformation?.collectorD365
                      }}</a>
                    </div>
                    <div class="row align-items-center">
                      <div class="col">
                        <div class="text d-flex align-items-center">
                           <i class="pi pi-envelope"></i>
                          <a
                            class="email"
                            [href]="clientBasicInformation?.collectorEmailD365"
                            >{{ clientBasicInformation?.collectorEmailD365 }}</a
                          >
                        </div>
                      </div>
                      <div class="col">
                        <div class="text d-flex align-items-center">
                           <i class="pi pi-phone"></i>
                          <a
                            class="tel"
                            [href]="clientBasicInformation?.collectionContact"
                            >{{ clientBasicInformation?.collectionContact }}</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <div class="title mb-1">
                      Billing Rep:
                      <a class="link">{{
                        clientBasicInformation?.billingRepD365
                      }}</a>
                    </div>
                    <div class="row align-items-center">
                      <div class="col">
                        <div class="text d-flex align-items-center">
                           <i class="pi pi-envelope"></i>
                          <a
                            class="email"
                            [href]="
                              'mailto:' +
                              clientEmployeeInformation?.displayEmailAs
                            "
                            >{{ clientEmployeeInformation?.displayEmailAs }}</a
                          >
                        </div>
                      </div>
                      <div class="col px-0">
                        <div class="text d-flex align-items-center">
                           <i class="pi pi-phone"></i>
                          <a
                            class="tel"
                            [href]="
                              'tel:' +
                              clientEmployeeInformation?.displayPhoneNumber
                            "
                            >{{
                              clientEmployeeInformation?.displayPhoneNumber
                            }}</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </footer>
            </div>
          </p-panel>
        </div>
        <div class="clientdetails-section mb-4">
          <p-panel [toggleable]="true" [(collapsed)]="isCollapseOne">
            <ng-template pTemplate="header">
              <div
                class="d-flex align-items-center justify-content-between ">
                <h2 class="mb-0 me-auto">Credit Management</h2>
                <div class="ml-auto d-flex align-items-center me-3">
                  <div class="title me-2">Request Credit Increase</div>
                  <div class="form-check form-switch d-flex gap-2 align-items-center">
                    <input pInputText 
                      class="form-check-input me-2"
                      [checked]="
                        clientBasicInformation?.isRequestCreditIncrease
                      "
                      type="checkbox"
                      id="rcIncrease"
                      name="rcIncrease"
                      (click)="onRequestCreditChange($event)"
                      formControlName="isRequestCreditIncrease"
                      (focusout)="updateClientSummaryData()" />
                    <label class="form-check-label" for="rcIncrease">{{
                      clientBasicInformation?.isRequestCreditIncrease
                    }}</label>
                  </div>
                </div>
                <div class="ml-auto d-flex align-items-center">
                  <input pInputText 
                    jniAutoCompleteBlocker
                    type="text"
                    style="width: 102px"
                    id="requestCreditIncreaseAmount"
                    name="requestCreditIncreaseAmount"
                    [value]="
                      clientBasicInformation?.requestCreditIncreaseAmount
                    "
                    class="form-control me-2"
                    formControlName="requestCreditIncreaseAmount"
                    (focusout)="updateClientSummaryData()" />
                  <div class="text">Amount</div>
                </div>
              </div>
            </ng-template>
            <div class="px-3 py-4 pb-0">
              <div class="row">
                <div class="col-3 mb-3">
                  <div class="title">Currency:</div>
                  <div class="text">
                    {{ clientBasicInformation?.salesCurrencyCodeD365 }}
                  </div>
                </div>
                <div class="col-9 mb-3">
                  <div class="credit-details row mx-0">
                    <div class="limit px-0 col">
                      <div class="py-1 px-3">CR Limit</div>
                      <div class="py-1 px-3 colored">
                        {{ clientBasicInformation?.creditLimitD365 | currency }}
                      </div>
                    </div>
                    <div class="receivables px-0 col">
                      <div class="py-1 px-3">Open Receivables</div>
                      <div class="py-1 px-3 colored">
                        <a
                          class="link"
                          (click)="
                            redirectToArAgingDetailsReport(clientId, 'All')
                          "
                          >{{ openReceivables | currency }}</a
                        >
                      </div>
                    </div>
                    <div class="backlog px-0 col">
                      <div class="py-1 px-3">Backlog</div>
                      <div class="py-1 px-3 colored">
                        {{ openOrders | currency }}
                      </div>
                    </div>
                    <div class="available px-0 col">
                      <div class="py-1 px-3">Available</div>
                      <div class="py-1 px-3 colored">
                        {{ customerBalance | currency }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-3 mb-3">
                  <div class="title">Invoicing & Delivery On Hold:</div>
                  <div class="text">
                    {{
                      clientBasicInformation?.isInvoicingAndDeliveryOnHoldD365
                    }}
                  </div>
                </div>
                <div class="col-3 mb-3">
                  <div class="title">Credit Limit:</div>
                  <div class="text">
                    <span class="bold">{{
                      clientBasicInformation?.creditLimitD365 | currency
                    }}</span>
                  </div>
                </div>
                <div class="col-3 mb-3">
                  <div class="title">Credit Status:</div>
                  <div class="text">
                    <span class="green">{{
                      clientBasicInformation?.creditStatus
                    }}</span>
                  </div>
                </div>
                <div class="col-3 mb-3">
                  <div class="title">Last Credit Check Date:</div>
                  <div class="text">
                    {{
                      clientBasicInformation?.lastCreditCheckDateD365 ===
                      "1900-01-01T12:00:00"
                        ? ""
                        : (clientBasicInformation?.lastCreditCheckDateD365
                          | date: "MM-dd-yyyy")
                    }}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-3 mb-3">
                  <div class="title">Credit Rating:</div>
                  <div class="text">
                    {{ clientBasicInformation?.creditRatingD365 }}
                  </div>
                </div>
                <div class="col-3 mb-3">
                  <div class="title">Collection Contact:</div>
                  <div class="text">
                    <a class="link">{{
                      clientBasicInformation?.collectionContact
                    }}</a>
                  </div>
                </div>
                <div class="col-3 mb-3">
                  <div class="title">Default Write-Off Reason:</div>
                  <div class="text">
                    <a class="link">{{
                      clientBasicInformation?.custWriteOffReasonD365
                    }}</a>
                  </div>
                </div>
                <div class="col-3 mb-3">
                  <div class="title">Statistic Group:</div>
                  <div class="text">
                    {{ clientBasicInformation?.statisticsGroupIdD365 }}
                  </div>
                </div>
              </div>
            </div>
          </p-panel>
        </div>
      </form>
      <div class="clientdetails-section mb-4">
        <p-panel [toggleable]="true" [(collapsed)]="isCollapseTwo">
          <ng-template pTemplate="header">
            <div
              class="d-flex align-items-center justify-content-between ">
              <h2 class="m-0">Client Contract</h2>
              <div class="lds-ring inline me-auto ms-2" *ngIf="showSmallLoader">
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div class="ml-auto d-flex align-items-center me-3">
                <div class="title me-2">
                  Note contract when creating new orders
                </div>
                <div class="form-check form-switch d-flex gap-2 align-items-center">
                  <input pInputText 
                    class="form-check-input me-2"
                    checked
                    type="checkbox"
                    id="rcIncrease"
                    name="rcIncrease" />
                  <label class="form-check-label" for="rcIncrease">Yes</label>
                </div>
              </div>
            </div>
          </ng-template>
          <div class="px-3 py-4 pb-0">
            <div
              class="row"
              *ngFor="let item of clientContractInformation; let i = index">
              <div class="col-4 mb-4">
                <div class="d-flex align-items-center justify-content-between">
                  <div class="form-group has-float-label flex-grow-1">
                    <input pInputText 
                      jniAutoCompleteBlocker
                      type="text"
                      class="form-control"
                      id="contact"
                      name="contact"
                      [(ngModel)]="item.contractTitle"
                      (onChange)="onContactTitleChange(item)" />
                    <label class="form-label" for="contact"
                      >Contact title {{ i + 1 }}
                    </label>
                  </div>
                  <a class="icon-Notes ms-2"></a>
                </div>
              </div>
              <div class="col-3 mb-4">
                <div class="form-group has-float-label">
                  <p-calendar pInputText 
                    jniAutoCompleteBlocker
                    inputId="EffectFrom"
                    class="form-control"
                    [(ngModel)]="item.effectiveFrom"
                    (onSelect)="onClientContactDateChange($event, item)"
                    [showOtherMonths]="true"
                    [selectOtherMonths]="true"
                    [showIcon]="true"
                    dateFormat="mm-dd-yy">
                  </p-calendar>
                  <label class="form-label" for="EffectFrom">Effect From</label>
                </div>
              </div>
              <div class="col-3 mb-4">
                <div class="form-group has-float-label">
                  <p-calendar pInputText 
                    jniAutoCompleteBlocker
                    inputId="EffectTo"
                    class="form-control"
                    [(ngModel)]="item.effectiveTo"
                    (onSelect)="onClientContactDateChange($event, item)"
                    [showOtherMonths]="true"
                    [selectOtherMonths]="true"
                    [showIcon]="true"
                    dateFormat="mm-dd-yy">
                  </p-calendar>
                  <label class="form-label" for="EffectTo">Effect To</label>
                </div>
              </div>
              <div class="col-2 mb-4">
                <div class="form-group mt-1 d-flex align-items-center">
                  <label
                    [attr.for]="'file' + (i + 1)"
                    style="cursor: pointer"
                    class="d-flex align-items-center file">
                    <input pInputText 
                      type="file"
                      [attr.id]="'file' + (i + 1)"
                      style="display: none"
                      (onChange)="getClientContactTitleOneFile($event, item)" />
                    <i class="icon-Upload me-2"></i> Upload
                  </label>
                  <div class="ms-1 file" *ngIf="item.uri !== ''">
                    <a class="file-download" [href]="item.uri" target="_blank"
                      ><i class="icon-eye"></i
                    ></a>
                  </div>
                </div>
                <span
                  class="text-primary small"
                  data-toggle="tooltip"
                  [title]="item.fileName">
                  {{ item.fileName }}
                </span>
                <div class="error" *ngIf="contactoneFileSize">
                  File must be less than 1 MB
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-4 mb-4">
                <div class="title mb-1">Client PO Required</div>
                <div class="form-check form-switch d-flex gap-2 align-items-center">
                  <input pInputText 
                    class="form-check-input me-2"
                    type="checkbox"
                    id="updateCustomerPoField"
                    [(ngModel)]="PoCheck"
                    (click)="updateCustomerPoField($event)"
                    name="updateCustomerPoField" />
                </div>
                <label class="form-check-label">{{ PoCheck }}</label>
              </div>
              <div class="col-3 mb-4">
                <div class="form-group has-float-label">
                  <p-calendar pInputText 
                    jniAutoCompleteBlocker
                    inputId="basic"
                    class="date-input"
                    [(ngModel)]="effectFrom"
                    (onSelect)="onCustomerEffectFromDate($event)"
                    [showOtherMonths]="true"
                    [selectOtherMonths]="true"
                    [showIcon]="true"></p-calendar>
                  <label class="form-label">Client PO Effect From</label>
                </div>
              </div>
              <div class="col-3 mb-4">
                <div class="form-group has-float-label">
                  <p-calendar pInputText 
                    jniAutoCompleteBlocker
                    inputId="basic"
                    class="date-input"
                    [(ngModel)]="effectTo"
                    (onSelect)="onCustomerEffectToDate($event)"
                    [showOtherMonths]="true"
                    [selectOtherMonths]="true"></p-calendar>
                  <label class="form-label">Client PO Effect To</label>
                </div>
              </div>
            </div>
          </div>
        </p-panel>
      </div>
      <form [formGroup]="miscellaneousDataForm">
        <div class="clientdetails-section mb-4">
          <p-panel [toggleable]="true" [(collapsed)]="isCollapseThree">
            <ng-template pTemplate="header">
              <div
                class="d-flex align-items-center justify-content-between ">
                <h2 class="mb-0">Miscellaneous Data</h2>
              </div>
            </ng-template>
            <div class="px-3 py-4 pb-0">
              <div class="row">
                <div class="col-3 mb-3">
                  <div class="title">Shipping Method:</div>
                  <input pInputText 
                    jniAutoCompleteBlocker
                    type="text"
                    [value]="clientBasicInformation?.shippingMethodD365"
                    id="shippingmethod"
                    class="hideborder"
                    formControlName="shippingMethodD365"
                    (focusout)="updateClientSummaryData()" />
                </div>
                <div class="col-4 mb-3">
                  <div class="title">Client Freight Account Number:</div>
                  <input pInputText 
                    jniAutoCompleteBlocker
                    type="text"
                    id="clientfreight"
                    class="hideborder"
                    formControlName="rsmJNIClientFreightAcctD365"
                    (focusout)="updateClientSummaryData()" />
                </div>
              </div>
              <div class="row">
                <div class="col-3 mb-3">
                  <div class="title">Term Of Payment:</div>
                  <a class="link">{{
                    clientBasicInformation?.paymentTermsD365
                  }}</a>
                </div>
                <div class="col-3 mb-3">
                  <div class="title">Sale Tax Group:</div>
                  <div class="text">
                    <a class="link">{{
                      clientBasicInformation?.salesTaxgroupD365
                    }}</a>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-3 mb-3">
                  <div class="title">Delivery Terms:</div>
                  <a class="link">{{
                    clientBasicInformation?.deliveryTermsD365
                  }}</a>
                </div>
                <div class="col-3 mb-3">
                  <div class="title">Priority:</div>
                  <input pInputText 
                    jniAutoCompleteBlocker
                    type="text"
                    id="Priority"
                    class="hideborder"
                    formControlName="priority" />
                </div>
                <div class="col-3 mb-3">
                  <div class="title">Legacy Number:</div>
                  <div class="text">
                    {{ clientBasicInformation?.salesAccountNumberD365 }}
                  </div>
                </div>
              </div>
            </div>
          </p-panel>
        </div>
      </form>
    </div>
    <div class="col-4">
      <div class="clientdetails-section">
        <p-panel [toggleable]="true" [(collapsed)]="isCollapseFour">
          <ng-template pTemplate="header">
            <div
              class="d-flex align-items-center justify-content-between p-3 pe-5">
              <h2 class="mb-0">Contact Information</h2>
              <span
                class="link icon-Add ms-auto me-3"
                (click)="addContactInformation()"></span>
              <a class="link" (click)="viewContactInformation()">Manage</a>
            </div>
          </ng-template>
          <p-scroller [style]="'height:250px;'">
            <div class="px-3 py-4 pb-2">
              <div class="mb-4" *ngFor="let item of ClientAddresses">
                <ng-container
                  *ngIf="
                    clientType === 'client' ||
                    (clientType === 'prospect' && item?.cust)
                  ">
                  <h3 class="mb-0">{{ item.purpose }}</h3>
                  <div class="d-flex align-items-center mb-1">
                    <span class="me-1" (click)="onEditContact(item)"
                      ><strong>Name:</strong></span
                    >
                    <span class="text name me-1" (click)="onEditContact(item)"
                      ><a class="link"
                        ><u>{{ item.name }}</u></a
                      ></span
                    >
                    <span
                      class="badge bg-primary"
                      *ngIf="item?.isPrimary?.toLowerCase() === 'yes'"
                      >Primary</span
                    >
                  </div>
                  <div class="row align-items-center">
                    <div
                      class="col d-flex align-items-center justify-content-between">
                      <div class="text d-flex align-items-center">
                         <i class="pi pi-envelope"></i>
                        <a class="email" [href]="item.emailLink">{{
                          item.email
                        }}</a>
                      </div>
                      <div class="text d-flex align-items-center">
                         <i class="pi pi-phone"></i>
                        <a class="tel" [href]="item.phoneLink">{{
                          item.phone
                        }}</a>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </p-scroller>
        </p-panel>
      </div>

      <div class="billing mt-4">
        <form [formGroup]="clientSummaryForm">
          <div class="attention mb-4">
            <strong><span class="title">Attention:</span></strong>
            <input pInputText 
              jniAutoCompleteBlocker
              type="text"
              id="billingAttentionD365"
              class="hideborder"
              formControlName="billingAttentionD365"
              [maxlength]="30"
              (focusout)="updateClientSummaryData()" />
          </div>
          <div class="location mb-4">
            <strong><span class="title">Location:</span></strong>
            <input pInputText 
              jniAutoCompleteBlocker
              type="text"
              id="billingLocationD365"
              class="hideborder"
              formControlName="billingLocationD365"
              [maxlength]="30"
              (focusout)="updateClientSummaryData()" />
          </div>
        </form>
      </div>

      <div class="clientdetails-section mb-4">
        <p-panel [toggleable]="true" [(collapsed)]="isCollapseFive">
          <ng-template pTemplate="header">
            <div
              class="d-flex align-items-center justify-content-between p-3 pe-5">
              <h2 class="mb-0">Addresses</h2>
              <span
                class="link icon-Add ms-auto me-3"
                (click)="onCreateAddress()"></span>
              <a class="link" (click)="onAddressView()">Manage</a>
            </div>
          </ng-template>
          <p-scroller [style]="'height:250px;'">
            <div class="px-3 py-4 pb-2">
              <div
                class="mb-4 d-flex"
                *ngFor="let item of clientAddressInformation; let i = index">
                <div class="icon">
                  <i class="icon-Protection-days"></i>
                </div>
                <div class="ms-2 flex-grow-1">
                  <div
                    class="d-flex align-items-center justify-content-between mb-1">
                    <h3 class="mb-0 me-1" *ngIf="item.purposeD365 === '1'">
                      Business
                    </h3>
                    <h3 class="mb-0 me-1" *ngIf="item.purposeD365 === '2'">
                      Invoice
                    </h3>
                    <h3 class="mb-0 me-1" *ngIf="item.purposeD365 === '3'">
                      Payment
                    </h3>
                    <h3 class="mb-0 me-1" *ngIf="item.purposeD365 === '4'">
                      Delivery
                    </h3>
                    <h3 class="mb-0 me-1" *ngIf="item.purposeD365 === '5'">
                      Other
                    </h3>
                    <span
                      class="badge bg-primary me-auto"
                      *ngIf="item.isPrimaryD365 === 'Yes'"
                      >Primary
                      <b *ngIf="item?.descriptionD365"
                        >- {{ item.descriptionD365 }}</b
                      >
                    </span>
                    <span
                      *ngIf="!(item.isPrimaryD365 === 'Yes')"
                      class="tag ml-auto"
                      >{{ extractRoles(item.rolesD365) }}
                      <b *ngIf="item?.descriptionD365"
                        >- {{ item.descriptionD365 }}</b
                      >
                    </span>
                  </div>
                  <div class="d-flex">
                    <i class="icon-address me-1"></i>
                    <address
                      class="mb-0 address"
                      (click)="onEditAddress(item)"
                      *ngIf="
                        item.addressD365 === '' && item.zipCodeD365 !== ''
                      ">
                      {{
                        item.streetD365 +
                          item.streetNumberD365 +
                          item.cityD365 +
                          ", " +
                          item.stateD365 +
                          ", " +
                          item.zipCodeD365
                      }}
                    </address>
                    <address
                      class="mb-0 address"
                      *ngIf="item.addressD365 !== ''"
                      (click)="onEditAddress(item)">
                      {{ item.addressD365 }}
                    </address>
                  </div>
                </div>
              </div>
            </div>
          </p-scroller>
        </p-panel>
      </div>
      <div class="clientdetails-section mb-4">
        <header
          class="d-flex align-items-center justify-content-between p-3 pe-5 position-relative">
          <h2 class="mb-0">Commission Setup</h2>
          <a class="link">Request Split</a>
          <button
            class="toggle-btn"
            (click)="isCollapseSix = !isCollapseSix"
            [attr.aria-expanded]="!isCollapseSix"></button>
        </header>
        <p-panel [toggleable]="true" [(collapsed)]="isCollapseSix">
          <ng-template pTemplate="header">
            <div
              class="d-flex align-items-center justify-content-between ">
              <h2 class="mb-0">Commission Setup</h2>
              <a class="link">Request Split</a>
            </div>
          </ng-template>
          <div class="px-3 py-4 pb-0">
            <p-scroller [style]="'height:150px;'">
              <div
                class="mb-4"
                *ngFor="
                  let commission of clientCommissionInformation;
                  let i = index
                ">
                <div class="text mb-3">
                  {{ commission.employees?.firstName }}
                  {{ commission.employees?.lastName }}
                  ({{ commission.employees?.personnelNumber }})
                  <strong
                    >{{
                      commission.customerCommissions?.commissionSplitPercentD365
                        | number
                    }}%</strong
                  >
                </div>
              </div>
            </p-scroller>
          </div>
        </p-panel>
      </div>
      <div class="clientdetails-section mb-4">
        <p-panel [toggleable]="true" [(collapsed)]="isCollapseSeven">
          <ng-template pTemplate="header">
            <div
              class="d-flex align-items-center justify-content-between p-3 pe-5">
              <h2 class="mb-0">Default Financial Dimension</h2>
            </div>
          </ng-template>
          <div class="px-3 py-4 pb-0">
            <div class="row">
              <div class="col mb-4">
                <div class="form-group has-float-label add">
                  <input pInputText 
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control px-0"
                    id="department"
                    name="department"
                    [value]="dimensionDepartmentCodeD365"
                    disabled />
                  <label for="department">Department</label>
                </div>
              </div>
              <div class="col mb-4">
                <div class="form-group has-float-label add">
                  <input pInputText 
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control px-0"
                    id="salse"
                    name="salse"
                    placeholder=""
                    [value]="dimensionDepartmentValueD365"
                    disabled />
                  <label for="sale"></label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col mb-4">
                <div class="form-group has-float-label add">
                  <input pInputText 
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control px-0"
                    id="location"
                    name="location"
                    [value]="dimensionLocationsCodeD365"
                    disabled />
                  <label for="location">Location</label>
                </div>
              </div>
              <div class="col mb-4">
                <div class="form-group has-float-label add">
                  <input pInputText 
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control px-0"
                    id="denver"
                    name="denver"
                    placeholder=""
                    [value]="dimensionLocationValueD365"
                    disabled />
                  <label for="denver"></label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col mb-4">
                <div class="form-group has-float-label add">
                  <input pInputText 
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control px-0"
                    id="default"
                    name="default"
                    placeholder=""
                    [value]="dimensionProgramCodeD365"
                    disabled />
                  <label for="default">Program</label>
                </div>
              </div>
              <div class="col mb-4">
                <div class="form-group has-float-label add">
                  <input pInputText 
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control px-0"
                    id="program"
                    name="program"
                    placeholder=""
                    [value]="dimensionProgramValueD365"
                    disabled />
                  <label for="program"></label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col mb-4">
                <div class="form-group has-float-label add">
                  <input pInputText 
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control px-0"
                    id="default"
                    name="default"
                    placeholder=""
                    [value]="dimensionProgramSubCategoryCode"
                    disabled />
                  <label for="default">Product Sub Category</label>
                </div>
              </div>
              <div class="col mb-4">
                <div class="form-group has-float-label add">
                  <input pInputText 
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control px-0"
                    id="program"
                    name="program"
                    placeholder=""
                    [value]="dimensionProgramSubCategoryValue"
                    disabled />
                  <label for="program"></label>
                </div>
              </div>
            </div>
          </div>
        </p-panel>
      </div>
    </div>
  </div>
</div> -->

<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <div class="row stacker-body" [ngClass]="isModal ? 'p-3' : 'p-4'">
        <div
          class="d-flex justify-content-between align-items-center globalborder-btm-header mb-4 pb-3 px-0">
          <span
            ><h2 class="mb-0">
              Client Summary -<a
                >Client # {{ clientId }} -
                {{ clientBasicInformation?.organizationNameD365 }}</a
              >
            </h2></span
          >
          <div class="d-flex justify-content-between align-items-center gap-3">
            <span
              class="d-flex justify-content-between align-items-center gap-3">
              <span>
                <a class="dropdown-item d-flex align-items-center gap-2"
                  >Last Order:
                  <div>
                    <time *ngIf="lastOrderDate | hidedynamicsdate">{{
                      lastOrderDate | date: "MM-dd-yyyy"
                    }}</time>
                  </div>
                </a></span
              >
              <span
                class="d-flex justify-content-between align-items-center gap-3"
                ><a class="dropdown-item d-flex align-items-center gap-2">
                  <div>
                    Invoice:
                    <time *ngIf="invoiceDate | hidedynamicsdate">{{
                      invoiceDate | date: "MM-dd-yyyy"
                    }}</time>
                  </div>
                </a>
              </span>
            </span>
            <span
              *ngIf="isModal"
              class="cross-border"
              (click)="closeClientModal()"
              ><i class="pi pi-times"></i
            ></span>
          </div>
        </div>

        <div class="clientdetailhgt px-0">
          <div class="col-12 px-0">
            <div class="d-flex gap-3">
              <div class="col pb-4 green-tag">
                <div class="text-center">
                  <div
                    class="card-body d-flex flex-column justify-content-center">
                    <h2 class="card-title mb-2">
                      {{ customerBalance | currency }}
                    </h2>
                    <p class="card-text">Available Credit</p>
                  </div>
                </div>
              </div>
              <div class="col pb-4 sky-tag">
                <div class="text-center order-five">
                  <div
                    class="card-body d-flex flex-column justify-content-center">
                    <h2 class="card-title mb-2">
                      {{ FYTDSales | currency }}
                    </h2>
                    <p class="card-text">FYTD Sales</p>
                  </div>
                </div>
              </div>
              <div class="col gray-tag pb-4">
                <div class="text-center order-one">
                  <div
                    class="card-body d-flex flex-column justify-content-center">
                    <h2 class="card-title mb-2">
                      {{ openOrders | currency }}
                    </h2>
                    <p class="card-text">Open Orders</p>
                  </div>
                </div>
              </div>
              <div class="col fer-tag pb-4">
                <a
                  class="link"
                  (click)="redirectToArAgingDetailsReport(clientId, '60')">
                  <div class="text-center order-two">
                    <div
                      class="card-body d-flex flex-column justify-content-center">
                      <h2 class="card-title mb-2">
                        {{ openInvoiceAmountTilesData.openAmount60 | currency }}
                      </h2>
                      <p class="card-text">60</p>
                    </div>
                  </div>
                </a>
              </div>
              <div class="col sky2-tag pb-4">
                <a
                  class="link"
                  (click)="redirectToArAgingDetailsReport(clientId, '90')">
                  <div class="text-center order-two">
                    <div
                      class="card-body d-flex flex-column justify-content-center">
                      <h2 class="card-title mb-2">
                        {{ openInvoiceAmountTilesData.openAmount90 | currency }}
                      </h2>
                      <p class="card-text">90</p>
                    </div>
                  </div>
                </a>
              </div>
              <div class="col darkgray-tag pb-4">
                <a
                  class="link"
                  (click)="redirectToArAgingDetailsReport(clientId, '120')">
                  <div class="text-center order-two">
                    <div
                      class="card-body d-flex flex-column justify-content-center">
                      <h2 class="card-title mb-2">
                        {{
                          openInvoiceAmountTilesData.openAmount120 | currency
                        }}
                      </h2>
                      <p class="card-text">120+</p>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div class="col-12 px-0">
            <div
              class="col d-flex align-items-center justify-content-between mb-3 mt-3">
              <ul class="nav sidenav">
                <li class="nav-item me-4">
                  <a
                    class="nav-link p-0"
                    (click)="redirectToOpenCustomerInvoices(clientId)"
                    aria-current="page"
                    >Open Customer Invoices</a
                  >
                </li>
                <li class="nav-item me-4">
                  <a class="nav-link p-0" (click)="orderHistoryRedirect()"
                    >Order History</a
                  >
                </li>

                <li class="nav-item me-4">
                  <a
                    class="nav-link p-0"
                    aria-current="page"
                    (click)="redirectClientArchive()"
                    >Archived Projects</a
                  >
                </li>
              </ul>
              <a
                (click)="onToggle()"
                [ngClass]="{ active: collapseStatus }"
                class="btn-collapse-all"
                >{{ collapseHeading }}
              </a>
            </div>
          </div>

          <div class="col-12 px-0">
            <form [formGroup]="clientSummaryForm">
              <div class="row">
                <div class="col-8">
                  <div>
                    <p-panel [toggleable]="true" [(collapsed)]="isCollapsed">
                      <ng-template pTemplate="header">
                        <div
                          class="d-flex align-items-center justify-content-between">
                          <h2 class="mb-0">Basic Information</h2>
                        </div>
                      </ng-template>
                      <div>
                        <div class="row">
                          <div class="col-3 mb-3">
                            <div class="title">Client Name:</div>
                            <div class="text">
                              {{ clientBasicInformation?.organizationNameD365 }}
                            </div>
                          </div>
                          <div class="col-3 mb-3">
                            <div class="title">Branding Consultant:</div>
                            <div class="text">
                              {{
                                clientBasicInformation?.brandingConsultantD365
                              }}
                            </div>
                          </div>
                          <div class="col-3 mb-3">
                            <div class="title">Brand Acc Coordinator:</div>
                            <p-select
                              [(ngModel)]="bacUserDefaultSelectionId"
                              (onChange)="updateClientSummaryData()"
                              formControlName="brandingAccountCordinator"
                              [options]="bacList"
                              optionValue="personnelNumber"
                              placeholder="Select Brand Acc Coordinator">
                              <ng-template let-item #item>
                                {{ item.personnelNumber }} :
                                {{ item.projectName }}
                              </ng-template>
                              <ng-template let-option #selectedItem>
                                {{ option.personnelNumber }} :
                                {{ option.projectName }}
                              </ng-template>
                            </p-select>
                          </div>
                          <div class="col-3 mb-3">
                            <div class="title">Known As:</div>
                            <input
                              pInputText
                              jniAutoCompleteBlocker
                              type="text"
                              id="bac"
                              class="hideborder"
                              formControlName="knownAsD365"
                              (focusout)="updateClientSummaryData()" />
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-3 mb-3">
                            <div class="title">
                              Client Group<span class="madatory-field">*</span>:
                            </div>
                            <p-select
                              (onChange)="updateClientSummaryData()"
                              formControlName="customerGroupIdD365"
                              [filter]="true"
                              [showClear]="true"
                              [options]="customerGroupList"
                              optionValue="customerGroupIdD365"
                              optionLabel="customerGroupIdD365"
                              placeholder="Select Facililator">
                            </p-select>
                          </div>
                          <div class="col-3 mb-3">
                            <div class="title">Type:</div>
                            <div class="text">
                              {{ clientBasicInformation?.partyTypeD365 }}
                            </div>
                          </div>
                          <div class="col-3 mb-3">
                            <div class="title">Parent Company Name:</div>
                            <p-autoComplete
                              [(ngModel)]="parentCompanyName"
                              [suggestions]="filteredParentCompanies"
                              (completeMethod)="filterParentCompanies($event)"
                              field="nameAliasD365"
                              [dropdown]="true"
                              [forceSelection]="true"
                              [formControlName]="'rsmJNIParentCompanyNameD365'"
                              (onBlur)="updateClientSummaryData()"
                              [styleClass]="'hideborder'"
                              placeholder="Search Parent Company"></p-autoComplete>
                          </div>
                          <div class="col-3 mb-3">
                            <div class="title">
                              Client Origin<span class="required">*</span>:
                            </div>
                            <p-select
                              id="source"
                              (onChange)="
                                updateClientSummaryData('sourceRequired')
                              "
                              formControlName="source"
                              [options]="sourceList"
                              optionValue="sourcetype"
                              optionLabel="sourcetype"
                              placeholder="Select sourcetype">
                            </p-select>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-3 mb-3">
                            <div class="title">Currency:</div>
                            <p-select
                              id="currency"
                              (onChange)="updateClientSummaryData()"
                              formControlName="salesCurrencyCodeD365"
                              [options]="currencyList"
                              optionValue="isoCurrencyCodeD365"
                              optionLabel="isoCurrencyCodeD365"
                              placeholder="Select isoCurrencyCodeD365">
                            </p-select>
                          </div>
                          <div class="col-3 mb-3">
                            <div class="title">
                              Company URL<span class="required">*</span>:
                            </div>
                            <input
                              pInputText
                              jniAutoCompleteBlocker
                              type="text"
                              id="companyurl"
                              class="hideborder"
                              formControlName="companyUrl"
                              (focusout)="
                                updateClientSummaryData('companyUrlRequried')
                              " />
                          </div>
                          <div class="col-3 mb-3">
                            <div class="title">DUNS#:</div>
                            <input
                              pInputText
                              jniAutoCompleteBlocker
                              type="text"
                              id="dunsno"
                              class="hideborder"
                              formControlName="dUNSNoD365"
                              (focusout)="updateClientSummaryData()" />
                          </div>
                          <div class="col-3 mb-3">
                            <div class="title mb-1">Request Credit Check:</div>
                            <div
                              class="form-check form-switch d-flex gap-2 align-items-center">
                              <p-toggleswitch
                                name="rcCheck"
                                [ngModel]="
                                  clientBasicInformation?.isRequestCreditCheck
                                "
                                type="checkbox"
                                (click)="onRequestCreditCheckSelection($event)"
                                id="rcCheck"
                                formControlName="isRequestCreditCheck"
                                (onChange)="updateClientSummaryData()" />
                              <label class="form-check-label" for="rcCheck">{{
                                clientBasicInformation?.isRequestCreditCheck
                              }}</label>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-3 mb-3">
                            <div class="title mb-1">Resale:</div>

                            <div
                              class="form-check form-switch d-flex gap-2 align-items-center">
                              <p-toggleswitch
                                checked
                                type="checkbox"
                                id="resalestatus"
                                name="resalestatus"
                                disabled
                                [ngModelOptions]="{ standalone: true }"
                                [ngModel]="clientBasicInformation?.isResale"
                                (click)="onIsResale($event)" />
                              <label
                                class="form-check-label"
                                for="resalestatus"
                                >{{ clientBasicInformation?.isResale }}</label
                              >
                            </div>
                          </div>
                          <div class="col-3 mb-3">
                            <div class="title">Resale Certificate:</div>

                            <div class="d-flex align-items-center gap-2">
                              <div>
                                <i
                                  class="pi pi-cloud-upload icon-blue mx-1"></i>
                              </div>

                              <div
                                class="text"
                                [hidden]="!clientBasicInformation?.isResale">
                                <a
                                  class="link"
                                  (click)="fileDownload(resaleAttachmenturl)"
                                  >{{ descriptionD365 }}</a
                                >
                              </div>
                              <div [hidden]="clientBasicInformation?.isResale">
                                <jni-attachment
                                  [attachmentLabel]="resale"
                                  [fileName]="resale"
                                  #myDiv
                                  (attachmentFileEvent)="
                                    attachmentFileObject($event)
                                  "></jni-attachment>
                              </div>
                            </div>
                          </div>
                          <div class="col-3 mb-3">
                            <div class="title mb-1">Tax Exemption#:</div>
                            <div
                              class="form-check form-switch d-flex gap-2 align-items-center">
                              <p-toggleswitch
                                [ngModel]="
                                  clientBasicInformation?.isTaxExemption
                                "
                                disabled
                                [ngModelOptions]="{ standalone: true }"
                                type="checkbox"
                                id="tAssumption"
                                name="tAssumption"
                                (click)="onTaxExemption($event)" />
                              <label
                                class="form-check-label"
                                for="tAssumption"
                                >{{
                                  clientBasicInformation?.isTaxExemption
                                }}</label
                              >
                            </div>
                          </div>
                          <div class="col-3 mb-3">
                            <div class="title">Tax Exemption:</div>
                            <div class="d-flex align-items-center gap-2">
                              <div>
                                <i
                                  class="pi pi-cloud-upload icon-blue mx-1"></i>
                              </div>
                              <div
                                class="text"
                                [hidden]="
                                  !clientBasicInformation?.isTaxExemption &&
                                  taxAttachmenturl !== ''
                                ">
                                <a
                                  class="link"
                                  (click)="fileDownload(taxAttachmenturl)"
                                  >{{ taxdescriptionD365 }}</a
                                >
                              </div>
                              <div
                                [hidden]="
                                  clientBasicInformation?.isTaxExemption
                                ">
                                <jni-attachment
                                  [attachmentLabel]="taxexemption"
                                  [fileName]="taxexemption"
                                  (attachmentFileEvent)="
                                    attachmentFileObject($event)
                                  "></jni-attachment>
                              </div>
                            </div>
                          </div>
                        </div>
                        <footer class="pt-3">
                          <div class="row">
                            <div class="col-3">
                              <div class="title mb-1">State Date:</div>
                              <div class="text">
                                {{
                                  clientBasicInformation?.createdDate
                                    | date: "MM-dd-yyyy"
                                }}
                              </div>
                            </div>
                            <div class="col">
                              <div class="title mb-1">
                                Collector:
                                <a class="link">{{
                                  clientBasicInformation?.collectorD365
                                }}</a>
                              </div>
                              <div class="row align-items-center">
                                <div class="col">
                                  <div class="text d-flex align-items-center">
                                    <i class="pi pi-envelope"></i>
                                    <a
                                      class="email"
                                      [href]="
                                        clientBasicInformation?.collectorEmailD365
                                      "
                                      >{{
                                        clientBasicInformation?.collectorEmailD365
                                      }}</a
                                    >
                                  </div>
                                </div>
                                <div class="col">
                                  <div
                                    class="text d-flex align-items-center gap-2">
                                    <i class="pi pi-phone"></i>
                                    <a
                                      class="tel"
                                      [href]="
                                        clientBasicInformation?.collectionContact
                                      "
                                      >{{
                                        clientBasicInformation?.collectionContact
                                      }}</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col">
                              <div class="title mb-1">
                                Billing Rep:
                                <a class="link">{{
                                  clientBasicInformation?.billingRepD365
                                }}</a>
                              </div>
                              <div class="row align-items-center">
                                <div class="col">
                                  <div
                                    class="text d-flex align-items-center gap-2">
                                    <i class="pi pi-envelope"></i>
                                    <a
                                      class="email"
                                      [href]="
                                        'mailto:' +
                                        clientEmployeeInformation?.displayEmailAs
                                      "
                                      >{{
                                        clientEmployeeInformation?.displayEmailAs
                                      }}</a
                                    >
                                  </div>
                                </div>
                                <div class="col px-0">
                                  <div
                                    class="text d-flex align-items-center gap-2">
                                    <i class="pi pi-phone"></i>
                                    <a
                                      class="tel"
                                      [href]="
                                        'tel:' +
                                        clientEmployeeInformation?.displayPhoneNumber
                                      "
                                      >{{
                                        clientEmployeeInformation?.displayPhoneNumber
                                      }}</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </footer>
                      </div>
                    </p-panel>
                  </div>

                  <div>
                    <p-panel [toggleable]="true" [(collapsed)]="isCollapseOne">
                      <ng-template pTemplate="header">
                        <div
                          class="d-flex align-items-center justify-content-between col-11">
                          <h2 class="mb-0 me-auto">Credit Management</h2>
                          <div class="ml-auto d-flex align-items-center me-3">
                            <div class="title me-2">
                              Request Credit Increase
                            </div>
                            <div
                              class="form-check form-switch d-flex gap-2 align-items-center">
                              <p-toggleswitch
                                [ngModel]="
                                  clientBasicInformation?.isRequestCreditIncrease
                                "
                                type="checkbox"
                                id="rcIncrease"
                                name="rcIncrease"
                                (click)="onRequestCreditChange($event)"
                                formControlName="isRequestCreditIncrease"
                                (focusout)="updateClientSummaryData()" />
                              <label
                                class="form-check-label"
                                for="rcIncrease"
                                >{{
                                  clientBasicInformation?.isRequestCreditIncrease
                                }}</label
                              >
                            </div>
                          </div>
                          <div class="ml-auto d-flex align-items-center">
                            <input
                              pInputText
                              jniAutoCompleteBlocker
                              type="text"
                              style="width: 102px"
                              id="requestCreditIncreaseAmount"
                              name="requestCreditIncreaseAmount"
                              [value]="
                                clientBasicInformation?.requestCreditIncreaseAmount
                              "
                              class="form-control me-2"
                              formControlName="requestCreditIncreaseAmount"
                              (focusout)="updateClientSummaryData()" />
                            <div class="text">Amount</div>
                          </div>
                        </div>
                      </ng-template>
                      <div>
                        <div class="row">
                          <div class="col-3 mb-3">
                            <div class="title">Currency:</div>
                            <div class="text">
                              {{
                                clientBasicInformation?.salesCurrencyCodeD365
                              }}
                            </div>
                          </div>
                          <div class="col-9 mb-3">
                            <div class="credit-details row mx-0">
                              <div class="limit px-0 col">
                                <div class="py-1 px-3">CR Limit</div>
                                <div class="py-1 px-3 colored">
                                  {{
                                    clientBasicInformation?.creditLimitD365
                                      | currency
                                  }}
                                </div>
                              </div>
                              <div class="receivables px-0 col">
                                <div class="py-1 px-3">Open Receivables</div>
                                <div class="py-1 px-3 colored">
                                  <a
                                    class="link"
                                    (click)="
                                      redirectToArAgingDetailsReport(
                                        clientId,
                                        'All'
                                      )
                                    "
                                    >{{ openReceivables | currency }}</a
                                  >
                                </div>
                              </div>
                              <div class="backlog px-0 col">
                                <div class="py-1 px-3">Backlog</div>
                                <div class="py-1 px-3 colored">
                                  {{ openOrders | currency }}
                                </div>
                              </div>
                              <div class="available px-0 col">
                                <div class="py-1 px-3">Available</div>
                                <div class="py-1 px-3 colored">
                                  {{ customerBalance | currency }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-3 mb-3">
                            <div class="title">
                              Invoicing & Delivery On Hold:
                            </div>
                            <div class="text">
                              {{
                                clientBasicInformation?.isInvoicingAndDeliveryOnHoldD365
                              }}
                            </div>
                          </div>
                          <div class="col-3 mb-3">
                            <div class="title">Credit Limit:</div>
                            <div class="text">
                              <span class="bold">{{
                                clientBasicInformation?.creditLimitD365
                                  | currency
                              }}</span>
                            </div>
                          </div>
                          <div class="col-3 mb-3">
                            <div class="title">Credit Status:</div>
                            <div class="text">
                              <span class="green">{{
                                clientBasicInformation?.creditStatus
                              }}</span>
                            </div>
                          </div>
                          <div class="col-3 mb-3">
                            <div class="title">Last Credit Check Date:</div>
                            <div class="text">
                              {{
                                formatCreditCheckDate(
                                  clientBasicInformation?.lastCreditCheckDateD365
                                )
                              }}
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-3 mb-3">
                            <div class="title">Credit Rating:</div>
                            <div class="text">
                              {{ clientBasicInformation?.creditRatingD365 }}
                            </div>
                          </div>
                          <div class="col-3 mb-3">
                            <div class="title">Collection Contact:</div>
                            <div class="text">
                              <a class="link">{{
                                clientBasicInformation?.collectionContact
                              }}</a>
                            </div>
                          </div>
                          <div class="col-3 mb-3">
                            <div class="title">Default Write-Off Reason:</div>
                            <div class="text">
                              <a class="link">{{
                                clientBasicInformation?.custWriteOffReasonD365
                              }}</a>
                            </div>
                          </div>
                          <div class="col-3 mb-3">
                            <div class="title">Statistic Group:</div>
                            <div class="text">
                              {{
                                clientBasicInformation?.statisticsGroupIdD365
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </p-panel>
                  </div>

                  <div>
                    <p-panel [toggleable]="true" [(collapsed)]="isCollapseTwo">
                      <ng-template pTemplate="header">
                        <div
                          class="d-flex align-items-center justify-content-between col-11">
                          <h2 class="m-0">Client Contract</h2>
                          <div
                            class="lds-ring inline me-auto ms-2"
                            *ngIf="showSmallLoader">
                            <div></div>
                            <div></div>
                            <div></div>
                          </div>
                          <div class="ml-auto d-flex align-items-center me-3">
                            <div class="title me-2">
                              Note contract when creating new orders
                            </div>
                            <div
                              class="form-check form-switch d-flex gap-2 align-items-center">
                              <label class="form-check-label" for="rcIncrease"
                                >Yes</label
                              >
                              <p-toggleswitch
                                checked
                                type="checkbox"
                                id="rcIncrease"
                                name="rcIncrease" />
                            </div>
                          </div>
                        </div>
                      </ng-template>
                      <div>
                        <div
                          class="row"
                          *ngFor="
                            let item of clientContractInformation;
                            let i = index
                          ">
                          <div class="col-4 mb-4">
                            <div
                              class="d-flex align-items-center justify-content-between">
                              <div
                                class="form-group has-float-label flex-grow-1">
                                <label class="form-label" for="contact"
                                  >Contact title {{ i + 1 }}
                                </label>
                                <input
                                  pInputText
                                  jniAutoCompleteBlocker
                                  type="text"
                                  class="form-control"
                                  id="contact"
                                  name="contact"
                                  [ngModelOptions]="{ standalone: true }"
                                  [(ngModel)]="item.contractTitle"
                                  (change)="onContactTitleChange(item)" />
                              </div>
                              <a class="icon-Notes ms-2"></a>
                            </div>
                          </div>
                          <div class="col-2 mb-4">
                            <div class="form-group has-float-label">
                              <label class="form-label" for="EffectFrom"
                                >Effect From</label
                              >
                              <p-calendar
                                #refEffectiveFrom
                                jniAutoCompleteBlocker
                                inputId="EffectFrom"
                                [(ngModel)]="item.effectiveFrom"
                                [ngModelOptions]="{ standalone: true }"
                                (onSelect)="
                                  onClientContactDateChange(
                                    $event,
                                    item,
                                    refEffectiveFrom
                                  )
                                "
                                [showOtherMonths]="true"
                                [selectOtherMonths]="true"
                                [showIcon]="true"
                                dateFormat="mm-dd-yy">
                              </p-calendar>
                            </div>
                          </div>
                          <div class="col-2 mb-4">
                            <div class="form-group has-float-label">
                              <label class="form-label" for="EffectTo"
                                >Effect To</label
                              >
                              <p-calendar
                                #refEffectiveTo
                                jniAutoCompleteBlocker
                                inputId="EffectTo"
                                [(ngModel)]="item.effectiveTo"
                                [ngModelOptions]="{ standalone: true }"
                                (onSelect)="
                                  onClientContactDateChange(
                                    $event,
                                    item,
                                    refEffectiveTo
                                  )
                                "
                                [showOtherMonths]="true"
                                [selectOtherMonths]="true"
                                [showIcon]="true"
                                dateFormat="mm-dd-yy">
                              </p-calendar>
                            </div>
                          </div>
                          <div class="col-4 mb-4 d-flex align-items-end gap-2">
                            <div
                              class="form-group mt-1 d-flex align-items-center gap-2">
                              <label
                                [attr.for]="'file' + (i + 1)"
                                class="d-flex align-items-center file gap-2">
                                <input
                                  pInputText
                                  type="file"
                                  [attr.id]="'file' + (i + 1)"
                                  style="display: none"
                                  (change)="
                                    getClientContactTitleOneFile($event, item)
                                  " />
                                <i class="pi pi-cloud-upload fs-2"></i>
                                <span>Upload</span>
                              </label>
                              <div
                                class="ms-1 file d-flex gap-2 align-items-center"
                                *ngIf="item.uri !== ''">
                                <a
                                  class="file-download"
                                  (click)="fileDownload(item.uri)">
                                  <i class="pi pi-eye fs-5 mt-1"></i
                                ></a>

                                <span
                                  class="text-primary small"
                                  data-toggle="tooltip"
                                  [title]="item.fileName">
                                  {{ item.fileName }}
                                </span>
                                <div class="error" *ngIf="contactoneFileSize">
                                  File must be less than 1 MB
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-4 mb-4">
                            <div class="title mb-1">Client PO Required</div>
                            <div
                              class="form-check form-switch d-flex gap-2 align-items-center">
                              <p-toggleswitch
                                type="checkbox"
                                id="updateCustomerPoField"
                                [ngModelOptions]="{ standalone: true }"
                                [(ngModel)]="PoCheck"
                                (click)="updateCustomerPoField($event)"
                                name="updateCustomerPoField" />
                            </div>
                          </div>
                          <div class="col-2 mb-4">
                            <div class="form-group has-float-label">
                              <label class="form-label"
                                >Client PO Effect From</label
                              >
                              <p-calendar
                                jniAutoCompleteBlocker
                                inputId="basic"
                                class="date-input"
                                [ngModelOptions]="{ standalone: true }"
                                [(ngModel)]="effectFrom"
                                (onSelect)="onCustomerEffectFromDate($event)"
                                [showOtherMonths]="true"
                                [selectOtherMonths]="true"
                                [showIcon]="true"></p-calendar>
                            </div>
                          </div>
                          <div class="col-3 mb-4">
                            <div class="form-group has-float-label">
                              <label class="form-label"
                                >Client PO Effect To</label
                              >
                              <p-calendar
                                jniAutoCompleteBlocker
                                inputId="basic"
                                class="date-input"
                                [(ngModel)]="effectTo"
                                [ngModelOptions]="{ standalone: true }"
                                (onSelect)="onCustomerEffectToDate($event)"
                                [showOtherMonths]="true"
                                [selectOtherMonths]="true"></p-calendar>
                            </div>
                          </div>
                        </div>
                      </div>
                    </p-panel>
                  </div>

                  <div>
                    <p-panel
                      [toggleable]="true"
                      [(collapsed)]="isCollapseThree">
                      <form [formGroup]="miscellaneousDataForm">
                        <ng-template pTemplate="header">
                          <div
                            class="d-flex align-items-center justify-content-between">
                            <h2 class="mb-0">Miscellaneous Data</h2>
                          </div>
                        </ng-template>
                        <div>
                          <div class="row">
                            <div class="col-3 mb-3">
                              <div class="title">Shipping Method:</div>
                              <input
                                pInputText
                                jniAutoCompleteBlocker
                                type="text"
                                [value]="
                                  clientBasicInformation?.shippingMethodD365
                                "
                                id="shippingmethod"
                                class="hideborder"
                                formControlName="shippingMethodD365"
                                (focusout)="updateClientSummaryData()" />
                            </div>
                            <div class="col-4 mb-3">
                              <div class="title">
                                Client Freight Account Number:
                              </div>
                              <input
                                pInputText
                                jniAutoCompleteBlocker
                                type="text"
                                id="clientfreight"
                                class="hideborder"
                                formControlName="rsmJNIClientFreightAcctD365"
                                (focusout)="updateClientSummaryData()" />
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-3 mb-3">
                              <div class="title">Term Of Payment:</div>
                              <a class="link">{{
                                clientBasicInformation?.paymentTermsD365
                              }}</a>
                            </div>
                            <div class="col-3 mb-3">
                              <div class="title">Sale Tax Group:</div>
                              <div class="text">
                                <a class="link">{{
                                  clientBasicInformation?.salesTaxgroupD365
                                }}</a>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-3 mb-3">
                              <div class="title">Delivery Terms:</div>
                              <a class="link">{{
                                clientBasicInformation?.deliveryTermsD365
                              }}</a>
                            </div>
                            <div class="col-3 mb-3">
                              <div class="title">Priority:</div>
                              <input
                                pInputText
                                jniAutoCompleteBlocker
                                type="text"
                                id="Priority"
                                class="hideborder"
                                formControlName="priority" />
                            </div>
                            <div class="col-3 mb-3">
                              <div class="title">Legacy Number:</div>
                              <div class="text">
                                {{
                                  clientBasicInformation?.salesAccountNumberD365
                                }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </p-panel>
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <p-panel [toggleable]="true" [(collapsed)]="isCollapseFour">
                      <ng-template pTemplate="header">
                        <div
                          class="d-flex align-items-center justify-content-between col-11">
                          <div class="d-flex gap-2">
                            <h2 class="mb-0">Contact Information</h2>
                            <span
                              class="icon-blue"
                              (click)="addContactInformation()">
                              <i class="pi pi-plus mx-1"></i
                              ><i class="pi pi-address-book"></i
                            ></span>
                          </div>
                          <a class="link" (click)="viewContactInformation()"
                            >Manage</a
                          >
                        </div>
                      </ng-template>
                      <div>
                        <div class="mb-4" *ngFor="let item of ClientAddresses">
                          <ng-container
                            *ngIf="
                              clientType === 'client' ||
                              (clientType === 'prospect' && item?.cust)
                            ">
                            <h3 class="mb-0">{{ item.purpose }}</h3>
                            <div class="d-flex align-items-center mb-1">
                              <span class="me-1" (click)="onEditContact(item)"
                                ><strong>Name:</strong></span
                              >
                              <span
                                class="text name me-1"
                                (click)="onEditContact(item)"
                                ><a class="link"
                                  ><u>{{ item.name }}</u></a
                                ></span
                              >
                              <span
                                class="badge bg-primary"
                                *ngIf="item?.isPrimary?.toLowerCase() === 'yes'"
                                >Primary</span
                              >
                            </div>
                            <div class="row align-items-center">
                              <div
                                class="col d-flex align-items-center justify-content-between">
                                <div
                                  class="text d-flex align-items-center gap-2">
                                  <i class="pi pi-envelope"></i>
                                  <a class="email" [href]="item.emailLink">{{
                                    item.email
                                  }}</a>
                                </div>
                                <div
                                  class="text d-flex align-items-center gap-2">
                                  <i class="pi pi-phone"></i>
                                  <a class="tel" [href]="item.phoneLink">{{
                                    item.phone
                                  }}</a>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </p-panel>
                  </div>

                  <div>
                    <strong><span class="title">Attention:</span></strong>
                    <input
                      pInputText
                      jniAutoCompleteBlocker
                      type="text"
                      id="billingAttentionD365"
                      class="hideborder"
                      formControlName="billingAttentionD365"
                      [maxlength]="30"
                      (focusout)="updateClientSummaryData()" />
                  </div>

                  <div>
                    <strong><span class="title">Location:</span></strong>
                    <input
                      pInputText
                      jniAutoCompleteBlocker
                      type="text"
                      id="billingLocationD365"
                      class="hideborder"
                      formControlName="billingLocationD365"
                      [maxlength]="30"
                      (focusout)="updateClientSummaryData()" />
                  </div>

                  <div class="mt-3">
                    <p-panel [toggleable]="true" [(collapsed)]="isCollapseFive">
                      <ng-template pTemplate="header">
                        <div
                          class="d-flex align-items-center justify-content-between col-11">
                          <div class="d-flex gap-2">
                            <h2 class="mb-0">Addresses</h2>
                            <span class="icon-blue" (click)="onCreateAddress()"
                              ><i class="pi pi-plus mx-1"></i
                              ><i class="pi pi-address-book"></i
                            ></span>
                          </div>
                          <a class="link" (click)="onAddressView()">Manage</a>
                        </div>
                      </ng-template>
                      <div>
                        <div
                          class="mb-4 d-flex"
                          *ngFor="
                            let item of clientAddressInformation;
                            let i = index
                          ">
                          <div class="icon">
                            <i class="icon-Protection-days"></i>
                          </div>
                          <div class="ms-2 flex-grow-1">
                            <div
                              class="d-flex align-items-center justify-content-between mb-1">
                              <h3
                                class="mb-0 me-1"
                                *ngIf="item.purposeD365 === '1'">
                                Business
                              </h3>
                              <h3
                                class="mb-0 me-1"
                                *ngIf="item.purposeD365 === '2'">
                                Invoice
                              </h3>
                              <h3
                                class="mb-0 me-1"
                                *ngIf="item.purposeD365 === '3'">
                                Payment
                              </h3>
                              <h3
                                class="mb-0 me-1"
                                *ngIf="item.purposeD365 === '4'">
                                Delivery
                              </h3>
                              <h3
                                class="mb-0 me-1"
                                *ngIf="item.purposeD365 === '5'">
                                Other
                              </h3>
                              <span
                                class="badge bg-primary me-auto"
                                *ngIf="item.isPrimaryD365 === 'Yes'"
                                >Primary
                                <b *ngIf="item?.descriptionD365"
                                  >- {{ item.descriptionD365 }}</b
                                >
                              </span>
                              <span
                                *ngIf="!(item.isPrimaryD365 === 'Yes')"
                                class="tag ml-auto"
                                >{{ extractRoles(item.rolesD365) }}
                                <b *ngIf="item?.descriptionD365"
                                  >- {{ item.descriptionD365 }}</b
                                >
                              </span>
                            </div>
                            <div class="d-flex">
                              <i class="icon-address me-1"></i>
                              <address
                                class="mb-0 address"
                                (click)="onEditAddress(item)"
                                *ngIf="
                                  item.addressD365 === '' &&
                                  item.zipCodeD365 !== ''
                                ">
                                {{
                                  item.streetD365 +
                                    item.streetNumberD365 +
                                    item.cityD365 +
                                    ", " +
                                    item.stateD365 +
                                    ", " +
                                    item.zipCodeD365
                                }}
                              </address>
                              <address
                                class="mb-0 address"
                                *ngIf="item.addressD365 !== ''"
                                (click)="onEditAddress(item)">
                                {{ item.addressD365 }}
                              </address>
                            </div>
                          </div>
                        </div>
                      </div>
                    </p-panel>
                  </div>

                  <div>
                    <!-- <header
                class="d-flex align-items-center justify-content-between mb-3">
                <h2 class="mb-0">Commission Setup</h2>
                <a class="link">Request Split</a>
                <button
                  class="toggle-btn"
                  (click)="isCollapseSix = !isCollapseSix"
                  [attr.aria-expanded]="!isCollapseSix"></button>
              </header> -->
                    <p-panel [toggleable]="true" [(collapsed)]="isCollapseSix">
                      <ng-template pTemplate="header">
                        <div
                          class="d-flex align-items-center justify-content-between gap-3 col-11">
                          <h2 class="mb-0">Commission Setup</h2>
                          <a class="link">Request Split</a>
                        </div>
                      </ng-template>
                      <div>
                        <div
                          class="mb-4"
                          *ngFor="
                            let commission of clientCommissionInformation;
                            let i = index
                          ">
                          <div class="text mb-3">
                            {{ commission.employees.firstName }}
                            {{ commission.employees.lastName }}
                            ({{ commission.employees.personnelNumber }})
                            <strong
                              >{{
                                commission.customerCommissions
                                  .commissionSplitPercentD365 | number
                              }}%</strong
                            >
                          </div>
                        </div>
                      </div>
                    </p-panel>
                  </div>

                  <div>
                    <p-panel
                      [toggleable]="true"
                      [(collapsed)]="isCollapseSeven">
                      <ng-template pTemplate="header">
                        <div
                          class="d-flex align-items-center justify-content-between">
                          <h2 class="mb-0">Default Financial Dimension</h2>
                        </div>
                      </ng-template>
                      <div>
                        <div class="row">
                          <div class="col mb-4">
                            <div class="form-group has-float-label add">
                              <label for="department">Department</label>
                              <input
                                pInputText
                                jniAutoCompleteBlocker
                                type="text"
                                class="form-control"
                                id="department"
                                name="department"
                                [value]="dimensionDepartmentCodeD365"
                                disabled />
                            </div>
                          </div>
                          <div class="col mb-4">
                            <div class="form-group has-float-label add">
                              <label for="sale"></label>
                              <input
                                pInputText
                                jniAutoCompleteBlocker
                                type="text"
                                class="form-control"
                                id="salse"
                                name="salse"
                                placeholder=""
                                [value]="dimensionDepartmentValueD365"
                                disabled />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col mb-4">
                            <div class="form-group has-float-label add">
                              <label for="location">Location</label>
                              <input
                                pInputText
                                jniAutoCompleteBlocker
                                type="text"
                                class="form-control"
                                id="location"
                                name="location"
                                [value]="dimensionLocationsCodeD365"
                                disabled />
                            </div>
                          </div>
                          <div class="col mb-4">
                            <div class="form-group has-float-label add">
                              <label for="denver"></label>
                              <input
                                pInputText
                                jniAutoCompleteBlocker
                                type="text"
                                class="form-control"
                                id="denver"
                                name="denver"
                                placeholder=""
                                [value]="dimensionLocationValueD365"
                                disabled />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col mb-4">
                            <div class="form-group has-float-label add">
                              <label for="default">Program</label>
                              <input
                                pInputText
                                jniAutoCompleteBlocker
                                type="text"
                                class="form-control"
                                id="default"
                                name="default"
                                placeholder=""
                                [value]="dimensionProgramCodeD365"
                                disabled />
                            </div>
                          </div>
                          <div class="col mb-4">
                            <div class="form-group has-float-label add">
                              <label for="program"></label>
                              <input
                                pInputText
                                jniAutoCompleteBlocker
                                type="text"
                                class="form-control"
                                id="program"
                                name="program"
                                placeholder=""
                                [value]="dimensionProgramValueD365"
                                disabled />
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col mb-4">
                            <div class="form-group has-float-label add">
                              <label for="default">Product Sub Category</label>
                              <input
                                pInputText
                                jniAutoCompleteBlocker
                                type="text"
                                class="form-control"
                                id="default"
                                name="default"
                                placeholder=""
                                [value]="dimensionProgramSubCategoryCode"
                                disabled />
                            </div>
                          </div>
                          <div class="col mb-4">
                            <div class="form-group has-float-label add">
                              <input
                                pInputText
                                jniAutoCompleteBlocker
                                type="text"
                                class="form-control"
                                id="program"
                                name="program"
                                placeholder=""
                                [value]="dimensionProgramSubCategoryValue"
                                disabled />
                              <label for="program"></label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </p-panel>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </p-card>
  </div>
</div>

<jni-modal-stacker
  *ngIf="openInvoiceDisplayModal"
  [displayModal]="openInvoiceDisplayModal"
  (closeEvent)="closeModal()">
  <h1 class="panelHeading">Open Invoice</h1>
  <div class="panelBody">
    <jni-client-invoice-amounts
      [openInvoiceCustomerAccount]="clientId"
      [openInvoicetype]="openInvoicetype"
      (closeModalOnRedirectionEvent)="closeModalOnRedirection($event)"
      (scrollHiddenStatus)="addScollHiddenClass()"></jni-client-invoice-amounts>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="openClientArchiveModal"
  [displayModal]="openClientArchiveModal"
  (closeEvent)="closeArchiveModal()">
  <h1 class="panelHeading">Production Workflow Listing</h1>
  <div class="panelBody">
    <jni-production-workflow-listing
      [customerId]="clientId"
      [isRedirectedFromClient]="true"
      [clientAlias]="clientInformation?.client?.nameAliasD365 ?? ''"
      (closeModalEvent)="closeArchiveModal()"
      [isModal]="true"></jni-production-workflow-listing>
  </div>
</jni-modal-stacker>
